
















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import DigitalCurrencyTransaction2TransactionShortIntroduction from './-2-transaction-short-introduction.vue'

@Component({
  components: {
    DigitalCurrencyTransaction2TransactionShortIntroduction
  }
})
class DigitalCurrencyTransaction1TransactionShortIntroductionButton extends Vue {
  @Prop({ default: false }) isIconButton?: boolean
  @Prop({ default: false }) isDepressedButton?: boolean
  @Prop({ default: '' }) transactionId?: string

  isVisibleTransactionShortIntroduction: boolean = false

  toggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.isVisibleTransactionShortIntroduction = isVisible
  }
}

export default DigitalCurrencyTransaction1TransactionShortIntroductionButton

